/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Author: rtql8d (https://sketchfab.com/rtql8d)
License: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
Source: https://sketchfab.com/3d-models/macbook-air-m2-786fa23d402a4f90ae36c4168997f9cc
Title: MacBook Air M2
*/
import * as THREE from "three"
import React, { useRef } from "react"
import { useGLTF, useTexture } from "@react-three/drei"

export function MacBook(props) {
	const { nodes, materials } = useGLTF("/models/macbook_air_m2.glb")
	return (
		<group {...props} dispose={null}>
			<group rotation={[-Math.PI / 2, 0, 0]}>
				<mesh castShadow receiveShadow geometry={nodes.Object_2.geometry} material={materials["Aluminum_-_Anodized_Glossy_Grey"]} scale={0.03} />
				<mesh
					castShadow
					receiveShadow
					geometry={nodes.Object_3.geometry}
					material={materials["Aluminum_-_Anodized_Glossy_Grey_keyboard.jpg"]}
					scale={0.03}
				/>
				<mesh castShadow receiveShadow geometry={nodes.Object_4.geometry} material={materials["Glass_-_Heavy_Color"]} scale={0.03} />
				<mesh castShadow receiveShadow geometry={nodes.Object_5.geometry} material={materials["Plastic_-_Translucent_Matte_Gray"]} scale={0.03} />
				<mesh castShadow receiveShadow geometry={nodes.Object_6.geometry} material={materials.Acrylic_Clear} scale={0.03} />
				<mesh castShadow receiveShadow geometry={nodes.Object_7.geometry} material={materials["Bronze_-_Polished"]} scale={0.03} />
				<mesh castShadow receiveShadow geometry={nodes.Object_8.geometry} material={materials["Rubber_-_Soft"]} scale={0.03} />
				<mesh castShadow receiveShadow geometry={nodes.Object_9.geometry} material={materials["Steel_-_Satin"]} scale={0.03} />
			</group>
		</group>
	)
}

useGLTF.preload("/models/macbook_air_m2.glb")
